import React from 'react';
import './ClickIcon.less';

export const ClickIcon = ({icon, onClick}) => {
	return <div className="click-icon" onClick={onClick} dangerouslySetInnerHTML={{__html: icon}}>
	</div>
}
